module.exports = __webpack_public_path__ + "img/fireworks.47a31007.png";